import { Component, EventEmitter, OnInit, Output, Input, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { Event } from "../../../models/event";
import { EventType } from "../../../models/event-type";
import { Role } from "../../../models/role";
import { Store } from "../../../services/store.service";
import {Institution} from "../../../models/institution";
import {RoleInstitution} from "../../../models/role-institution";
import { RoleManageComponent } from "./components/manage/role-manage.component";

@Component({
  selector: "app-new-role",
  templateUrl: "./new-role.component.html",
})
export class NewRoleComponent implements OnInit {

  public role: Role;
  public serviceId: string;
  @Input() public roleName: string;
  @Input() public showRoleAdd: boolean;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public institutions: Institution[];
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public modalAddedEvent = new EventEmitter();
  @ViewChild(RoleManageComponent) public roleManageComponent: RoleManageComponent;

  constructor(private router: Router, private route: ActivatedRoute, public store: Store) {
  }

  public ngOnInit() {
    this.getParams();
    this.role = new Role();
    this.role.name = this.roleName;
    this.role.shortName = this.roleName ? this.roleName.substring(0, 20) : "";
  }

  public getParams() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
  }

  public saveRole() {
    this.roleManageComponent.addNewRole();
  }

  public cancel() {
    this.modalClosedEvent.emit(new Event(null, EventType.Cancel));
  }

  public added() {
    this.modalAddedEvent.emit(new Event(null, EventType.Add));
  }

  public closeLayer() {
    this.router.navigate([`/services/${this.serviceId}/roles`]);
  }

}
